import { t } from '@avalara/bat-apps-shared/i18n';
import { SCardAction, SCol, SRow } from '@avalara/skylab-sdk/react';

import { openExternalLink } from '../../lib/helpers';
import { getResolvedUrl } from '../../lib/product-catalog';
import eventsData from './events-data.json';

import type { ProductCatalogEvent } from '../../../../types/product-catalog';

const events = eventsData.events as Array<ProductCatalogEvent>;

const EventsSection = () => {
  if (!events.length) return null;

  return (
    <>
      <SRow>
        <SCol>
          <h2 data-ref='buy.product-catalog.events.header'>{t('client.product-catalog.events-heading')}</h2>
        </SCol>
      </SRow>
      <SRow>
        {events.map((event) => {
          const learnMoreUrl = getResolvedUrl(event.learnMoreLink);

          return (
            <SCol key={event.id} data-ref={`buy.product-catalog.events.${event.id}.tile`} span='6'>
              <SCardAction className='product-catalog-card'>
                <div slot='title' className='product-catalog-card-title-slot'>
                  <h3>{event.title}</h3>
                  <p className='text-sm font-light margin-top-none'>{event.subtitle}</p>
                </div>
                <div slot='description' className='margin-top-none product-catalog-card-description'>
                  <p>{event.description}</p>
                </div>
                <div slot='footer'>
                  <button
                    type='button'
                    className='secondary'
                    data-ref={`buy.product-catalog.events.${event.id}.learn-more-button`}
                    onClick={() => openExternalLink(learnMoreUrl)}
                    disabled={!learnMoreUrl}
                  >
                    {t('client.general.learn-more')}
                  </button>
                </div>
              </SCardAction>
            </SCol>
          );
        })}
      </SRow>
    </>
  );
};

export default EventsSection;
